<div class="jh-popup" [ngClass]="validateSizing(data.size, 'jh-popup')">
  <!-- For loop over content -->
  <div *ngFor="let screen of data.screens">

    <!-- Show desired screen only !-->
    <ng-container *ngIf="screen.show">

      <!-- spinner -->
      <ng-container *ngIf="processing; else default">

        <!-- Titles -->
        <div class="jh-popup-top">
          <div class="jh-popup-header">
            <h1 style="display: none;"></h1>
            <h2>Sending email...</h2>
          </div>
        </div>
        <!--/Titles -->

        <!-- spinner -->
        <div class="row">
          <div class="col text-center">
            <mat-spinner></mat-spinner>
          </div>
        </div>
        <!-- /spinner -->

      </ng-container>
      <!-- /spinner -->

      <ng-template #default>
        <!-- Exit button 'x' -->
        <div *ngIf="screen.exit_btn" class="jh-btn-exit">
          <div class="ps-d-button-container">
            <i class="fas fa-times" (click)="close()" onkeypress="close()"></i>
          </div>
        </div>
        <!--/ Exit button 'x' -->

        <div *ngFor="let screenContent of screen.content">
          <!-- Start generating content -->

          <!-- Titles -->
          <div class="jh-popup-top" *ngIf="screenContent.type === 'title'">
            <div class="jh-popup-header">
              <h2 [innerHTML]="screenContent.content"></h2>
            </div>
          </div>
          <!--/Titles -->

          <!-- Content -->
          <mat-dialog-content>

            <!-- Group Text items-->
            <div *ngIf="screenContent.type === 'text_group'" class="modal-txt-wrapper">
              <p *ngFor="let text of screenContent['text_group']" [ngClass]="validateSizing(data.size, 'modal-p')"
                class="{{text.class}}" [innerHTML]="text.content">
              </p>
            </div>
            <!--/Group Text items-->

            <!-- Singular Text items-->
            <div *ngIf="screenContent.type === 'text'" class="modal-txt-wrapper {{screenContent.parentClass}} ?? ''">
              <p [ngClass]="validateSizing(data.size, 'modal-p')" class="{{screenContent.class}}"
                [innerHTML]="screenContent.content"></p>
            </div>
            <!--/Singular Text items-->

            <!-- Group link/anchor items-->
            <div *ngIf="screenContent.type === 'link_group'">
              <a *ngFor="let link of screenContent['link_group']" [ngClass]="validateSizing(data.size, 'modal-link')"
                class="{{screenContent.class}} modal-link-{{data.size}}" href="{{screenContent.href}}"
                (click)="this[screenContent.clickFunction]()" [innerHTML]="screenContent.content"></a>
            </div>
            <!--/Group  link/anchor items-->

            <!-- Singular  link/anchor items-->
            <div *ngIf="screenContent.type === 'link'">
              <a [ngClass]="validateSizing(data.size, 'modal-link')" class="{{screenContent.class}}"
                href="{{screenContent.href}}" (click)="this[screenContent.clickFunction]()"
                [innerHTML]="screenContent.content"></a>
            </div>
            <!--/Singular  link/anchor items-->

            <!-- Unordered list items -->
            <div *ngIf="screenContent.type === 'unordered_list'" [ngClass]="validateSizing(data.size, 'modal-ul')">
              <ul>
                <li *ngFor="let listItem of screenContent['unordered_list']"
                  [ngClass]="validateSizing(data.size, 'modal-li')" class="{{listItem.class}}"
                  [innerHTML]="listItem.content"></li>
              </ul>
            </div>
            <!--/Unordered list items -->

            <!-- Ordered list items -->
            <div *ngIf="screenContent.type === 'ordered_list'" [ngClass]="validateSizing(data.size, 'modal-ol')">
              <ul>
                <li *ngFor="let listItem of screenContent" [ngClass]="validateSizing(data.size, 'modal-li')"
                  class="{{listItem.class}}" [innerHTML]="listItem.content"></li>
              </ul>
            </div>
            <!--/Ordered list items -->

             <!-- Signators table -->
             <div *ngIf="screenContent.type === 'signators_table'" [ngClass]="validateSizing(data.size, 'modal-ol')">
              <div class="agent-portal-hide-on-mobile row" style="background-color: none !important">
                <div class="col-sm" style="font-weight:bold; padding-right:20px; border-right: 1px solid #ccc;">
                  Insured
                </div>
                <div class="col-sm">
                </div>
              </div>
              <div class="mobile-content row">
                <div class="col-sm" style="font-weight:bold;">
                  Insured
                </div>
                <div class="col-sm">
                </div>
              </div>
              <div class="row">
                <div class="agent-portal-hide-on-mobile col-sm" style="padding-right:20px; border-right: 1px solid #ccc;">
                  {{ screenContent.content.FirstName }} {{screenContent.content.LastName}}
                </div>
                <div class="mobile-content col-sm">
                  {{ screenContent.content.FirstName }} {{screenContent.content.LastName}}
                </div>
                <div *ngIf="screenContent.content.CustomerSigned == 1" class="col-sm">
                  Signed {{ screenContent.content.LastUpdated | date: 'MM/dd/yyyy'}}
                </div>
                <div *ngIf="screenContent.content.CustomerSigned == 0 && screenContent.content.insuredEmails" class="col-sm">
                  Unsigned : Sent {{screenContent.content.insuredEmails[screenContent.content.insuredEmails.length -1].created_at | date: 'MM/dd/yyyy'}}
                </div>
                <div *ngIf="screenContent.content.CustomerSigned == 0 && !screenContent.content.insuredEmails" class="col-sm">
                  Unsigned
                </div>
              </div>
               <div class="mobile-content">
                <hr style="font-weight:bold; height:1px solid #ccc;">
              </div>

              <div class="row">
                <div class="agent-portal-hide-on-mobile col-sm" style="font-weight:bold; padding-right:20px; border-right: 1px solid #ccc;">
                  Owners
                </div>
                <div class="mobile-content col-sm" style="font-weight:bold;">
                  Owners
                </div>
                <div class="col-sm">
                </div>
              </div>

              <div *ngFor="let signator of screenContent.content.OwnershipSignatories" class="row">
                <div *ngIf="signator.Role == 'IndividualOwner'" class="agent-portal-hide-on-mobile col-sm" style="padding-right:20px; border-right: 1px solid #ccc;">
                  {{ signator.FirstName }} {{signator.LastName}}
                </div>
                <div *ngIf="signator.Role == 'BusinessSignator'|| signator.Role == 'EntityTrustee' || signator.Role == 'IndividualTrustee' || signator.Role == 'Other'" class="agent-portal-hide-on-mobile col-sm" style="padding-right:20px; border-right: 1px solid #ccc;">
                  {{ signator.BusinessName }} : {{ signator.FirstName }} {{signator.LastName}}
                </div>
                <div *ngIf="signator.Role == 'IndividualOwner'" class="mobile-content col-sm">
                  {{ signator.FirstName }} {{signator.LastName}}
                </div>
                <div *ngIf="signator.Role == 'BusinessSignator' || signator.Role == 'EntityTrustee' || signator.Role == 'IndividualTrustee' || signator.Role == 'Other'" class="mobile-content col-sm">
                  {{ signator.BusinessName }} : {{ signator.FirstName }} {{signator.LastName}}
                </div>
                <div *ngIf="signator.Signed == true" class="col-sm">
                  Signed {{ signator.SignatureDate | date: 'MM/dd/yyyy'}}
                </div>
                <div *ngIf="signator.Signed == false && signator.OwnerEmails.length != 0" class="col-sm">
                  Unsigned : Sent {{(signator.OwnerEmails[signator.OwnerEmails.length -1].created_at).replace(' ','T') | date: 'MM/dd/yyyy'}}
                </div>
                <div *ngIf="signator.Signed == false && signator.OwnerEmails.length == 0" class="col-sm">
                  Unsigned
                </div>
                <div class="mobile-content col-sm">
                <br></div>
              </div>

            </div>
            <!--/Signators table -->

          </mat-dialog-content>
          <!--/Content -->

          <!-- Button group -->
          <ng-container *ngIf="screenContent.type === 'button_group'">
            <mat-dialog-actions>
              <div
                [ngClass]="[validateSizing(data.size, 'modal-btn-wrapper'), validateSizing(data.size, 'modal-btn-container-padding')]">
                <button *ngFor="let button of screenContent['buttons']" (click)="this[button.clickFunction]()"
                  class="{{button.class}} modal-btn-{{data.size}}" [ngClass]="validateSizing(data.size, 'modal-btn')"
                  [innerHtml]="button.label">
                </button>
              </div>
            </mat-dialog-actions>
          </ng-container>
          <!--/Button group-->

          <!-- Singular button -->
          <ng-container *ngIf="screenContent.type === 'button'">
            <mat-dialog-actions>
              <div
                [ngClass]="[validateSizing(data.size, 'modal-btn-wrapper'), validateSizing(data.size, 'modal-btn-container-padding')]">
                <button (click)="this[screenContent.clickFunction]()" class="{{screenContent.class}}"
                  [ngClass]="validateSizing(data.size, 'modal-btn')" [innerHtml]="screenContent.label">
                </button>
              </div>
            </mat-dialog-actions>
          </ng-container>
          <!--/Singular button -->

        </div>
      </ng-template>

      <!--/Generating content -->
    </ng-container>

  </div>
  <!--/For loop over content -->
</div>
